import { WordTiming } from 'src/models/Transcript'

// Seconds, like the timings and the player's currentTime: bridges short gaps between words, clears on a real pause.
export const WORD_GRACE_SECONDS = 0.3

export const TimingUtils = {
    getTimingByMediaOffset: (timings: WordTiming[], mediaOffset: number) =>
        timings.findLast((w) => mediaOffset >= w.mediaStart && mediaOffset - w.mediaEnd < WORD_GRACE_SECONDS) || null,
    getTimingByCharOffset: (timings: WordTiming[], charOffset: number) => timings.findLast((w) => charOffset >= w.charStart) || null,
}
